import {SplitMapper} from '@/api/models/Feeds.ts';
import {ChangeFn} from '@/pages/feeds/Editor/Mapper/Mappers/index.tsx';
import {FormGroup, InputGroup} from '@blueprintjs/core';
import {ChangeEventHandler, ReactElement, useCallback} from 'react';

interface Props {
	mapper: SplitMapper,
	onChange: ChangeFn,
}

export default function SplitMapperEditor({mapper, onChange}: Props): ReactElement {
	const onSplitPatternChange: ChangeEventHandler<HTMLInputElement> = useCallback(event => {
		onChange({
			...mapper,
			separator: event.currentTarget.value,
		})
	}, [onChange, mapper])

	return (
		<>
			<FormGroup label="Separator">
				<InputGroup onChange={onSplitPatternChange} value={mapper.separator} />
			</FormGroup>
		</>
	);
}
